module.exports = __webpack_public_path__ + "static/media/Culture-banner.c5a8a151.jpg";